import React, {Fragment, useState} from "react";
import Grid from "@mui/material/Grid";
import {useSelector} from "react-redux";
import CodeEditor from "../code-editor";
import I18nInputAdornmentSelect from "../i18n-input-adornment-select";
import {languageSelector, languagesSelector} from "../../state/app/appSelectors";

const I18nCodeEditor = codeEditorProps => {
  const languages = useSelector(languagesSelector);
  const defaultLanguage = useSelector(languageSelector);

  const [language, setLanguage] = useState(defaultLanguage);

  return (
    <Fragment>
      <Grid container justifyContent="flex-end" style={{marginBottom: 4}}>
        <Grid>
          <I18nInputAdornmentSelect value={language} onChange={lang => setLanguage(lang)} />
        </Grid>
      </Grid>
      <CodeEditor
        {...codeEditorProps}
        value={codeEditorProps.value && codeEditorProps.value[language] ? codeEditorProps.value[language] : ""}
        onChange={val => {
          const res = {};
          languages.forEach(lang => {
            if (codeEditorProps.value && codeEditorProps.value[lang]) {
              res[lang] = codeEditorProps.value[lang];
            }
          });
          res[language] = val;
          codeEditorProps.onChange(res);
        }}
      />
    </Fragment>
  );
};

export default I18nCodeEditor;
